__turbopack_context__.v({
  "center": "slideItem-module-scss-module__1NVWAW__center",
  "content": "slideItem-module-scss-module__1NVWAW__content",
  "contentPretitle": "slideItem-module-scss-module__1NVWAW__contentPretitle",
  "contentTitle": "slideItem-module-scss-module__1NVWAW__contentTitle",
  "ctaItems": "slideItem-module-scss-module__1NVWAW__ctaItems",
  "dark": "slideItem-module-scss-module__1NVWAW__dark",
  "left": "slideItem-module-scss-module__1NVWAW__left",
  "light": "slideItem-module-scss-module__1NVWAW__light",
  "link": "slideItem-module-scss-module__1NVWAW__link",
  "none": "slideItem-module-scss-module__1NVWAW__none",
  "price": "slideItem-module-scss-module__1NVWAW__price",
  "right": "slideItem-module-scss-module__1NVWAW__right",
  "shadedText": "slideItem-module-scss-module__1NVWAW__shadedText",
  "slideDesc": "slideItem-module-scss-module__1NVWAW__slideDesc",
  "slideItem": "slideItem-module-scss-module__1NVWAW__slideItem",
  "slideItemBackground": "slideItem-module-scss-module__1NVWAW__slideItemBackground",
  "slideItemGradiant": "slideItem-module-scss-module__1NVWAW__slideItemGradiant",
  "slideItemInner": "slideItem-module-scss-module__1NVWAW__slideItemInner",
  "slideItemVideoBackground": "slideItem-module-scss-module__1NVWAW__slideItemVideoBackground",
  "video": "slideItem-module-scss-module__1NVWAW__video",
});
